'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "SearchDismissOverlay": "Polaris-TopBar-SearchDismissOverlay",
  "visible": "Polaris-TopBar-SearchDismissOverlay--visible"
};

exports.default = styles;
